import { z } from 'zod/v3';
import { HtmlSnapshotTypeSchema } from '../generated/enums';

export const HtmlSnapshotDTOSchema = z.object({
  id: z.string(),
  timestamp: z.date().optional(),
  relativeTime: z.number().optional(),
  html: z.string(),
  markdown: z.string().optional().nullable(),
  url: z.string().optional(),
  pageId: z.string().optional().nullable(),
  domFingerprint: z.string().optional().nullable(),
  snapshotType: HtmlSnapshotTypeSchema.optional(),
  domState: z.record(z.string(), z.any()).optional().nullable(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export const CreateHtmlSnapshotDTOSchema = HtmlSnapshotDTOSchema.omit({
  createdAt: true,
  updatedAt: true,
});

export const UpdateHtmlSnapshotDTOSchema = z.object({
  id: z.string(),
  timestamp: z.date().optional(),
  relativeTime: z.number().optional(),
  html: z.string().optional(),
  markdown: z.string().optional().nullable(),
  url: z.string().optional(),
  pageId: z.string().optional().nullable(),
  domFingerprint: z.string().optional().nullable(),
  snapshotType: z.string().optional().nullable(),
  domState: z.record(z.string(), z.any()).optional().nullable(),
});

export type HtmlSnapshotDTO = z.infer<typeof HtmlSnapshotDTOSchema>;
export type CreateHtmlSnapshotDTO = z.infer<typeof CreateHtmlSnapshotDTOSchema>;
export type UpdateHtmlSnapshotDTO = z.infer<typeof UpdateHtmlSnapshotDTOSchema>;
